import { useEffect, useState } from 'react';

export const useConfirmationPage = ({ searchParams }) => {
    const [confirmationModalOpen, setConfirmationModalOpen] = useState(false);

    const isConfirmationPage = searchParams && searchParams.hasOwnProperty('confirmation');

    useEffect(() => {
        if (!isConfirmationPage) {
            return;
        }
        /**
         * a user successfuly created a new listing;
         * ?confirmation redirect is carried out by
         * payrexx system; the param is adde at
         * EditListingPricingPage/Form
         */
        setConfirmationModalOpen(true);
    }, [isConfirmationPage]);

    return [confirmationModalOpen, setConfirmationModalOpen];
};
